import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import Index from "./components";
import store from "@redux/store";
import Login from "./components/Login/Login";
import Client from "@frameworks/salesjourney/components/Features/ClientDetails/Client";
import CacheBuster from "react-cache-buster";
import SSO from "./components/SSO/SSO";
import MutualFund from "@frameworks/salesjourney/components/Features/ProductBouquet/ManagePortfolio/MutualFund/MutualFund";
import LoginHOC from "@frameworks/salesjourney/components/Login/common/LoginHOC";
import AuthGuardHOC from "@frameworks/salesjourney/components/Login/common/AuthGuardHOC";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import OtherApplicationLogin from "./components/OtherApplications/OtherApplicationsLogin";
// import "@frameworks/shared-library/stylesheets/components/index.scss";
//import "../salesjourney/stylesheets/components/Generic/GenericComponent.scss";
//import "../salesjourney/stylesheets/components/Generic/Generic.scss";
function App() {
    var isEnabled = process.env.NODE_ENV === "uat" ||
        process.env.NODE_ENV === "cug" ||
        process.env.NODE_ENV === "production";
    React.useEffect(function () {
        if (!localStorage.getItem(ELocalStorageKeys.InScope)) {
            localStorage.setItem(ELocalStorageKeys.InScope, "YES");
        }
        else if (localStorage.getItem(ELocalStorageKeys.InScope) &&
            localStorage.getItem(ELocalStorageKeys.InScope) === "NO") {
            localStorage.setItem(ELocalStorageKeys.InScope, "YES");
        }
        window.onbeforeunload = function () {
            window.removeEventListener("storage", checkLocalStorage);
        };
        function checkLocalStorage(event) {
            if (event.key === ELocalStorageKeys.InScope && event.newValue === "NO") {
                setTimeout(function () {
                    window.location.reload();
                }, 1000);
            }
        }
        window.addEventListener("storage", checkLocalStorage);
        return function () { return window.removeEventListener("storage", checkLocalStorage); };
    }, []);
    return (React.createElement(CacheBuster, { currentVersion: "5.4.1", isEnabled: isEnabled, reloadOnDowngrade: false, isVerboseMode: true, metaFileDirectory: process.env.PUBLIC_URL },
        React.createElement(BrowserRouter, { basename: process.env.PUBLIC_URL },
            React.createElement(Provider, { store: store },
                React.createElement(Routes, null,
                    React.createElement(Route, { path: "/*", element: React.createElement(AuthGuardHOC, { component: Index }) }),
                    React.createElement(Route, { path: "/login", element: React.createElement(LoginHOC, { component: Login }) }),
                    React.createElement(Route, { path: "/client-login", element: React.createElement(AuthGuardHOC, { component: Client }) }),
                    React.createElement(Route, { path: "/sso-login", element: React.createElement(SSO, null) }),
                    React.createElement(Route, { path: "/mf", element: React.createElement(MutualFund, null) }),
                    React.createElement(Route, { path: "/other-app-login", element: React.createElement(OtherApplicationLogin, null) }))))));
}
export default App;
